import { Typography } from "@fullscript/aviary-web";
import type { CategoryData } from "@/utils/server/mdx";
import * as styles from "./DocsItems.styles";
import { DocumentationNavItem } from "@/components/DocumentationNavItem/DocumentationNavItem";

const DocsItems = ({ categories }: { categories: CategoryData }) => {
  const gettingStartedCategories = categories["getting-started"];
  const howToGuidesCategories = categories["how-to-guides"];

  return (
    <div>
      <div>
        <Typography variant="caption" customCss={styles.title} isMarginless>
          GETTING STARTED
        </Typography>
        <div>
          {gettingStartedCategories.map(category => (
            <DocumentationNavItem key={category.title} category={category} />
          ))}
        </div>
      </div>
      <div css={styles.divider} />
      <div>
        <Typography variant="caption" customCss={styles.title} isMarginless>
          HOW TO GUIDES
        </Typography>
        <div>
          {howToGuidesCategories.map(category => (
            <DocumentationNavItem key={category.title} category={category} />
          ))}
        </div>
      </div>
    </div>
  );
};

export { DocsItems };
